import axios from 'axios'

const instance = axios.create({
    headers: {
        'Content-Type': 'application/json',
    }
});



let url = process.env.REACT_APP_URL
instance.defaults.baseURL = url
// instance.defaults.baseURL = '/api'; // for production
// instance.defaults.baseURL = 'http://127.0.0.1:8000/api';

instance.interceptors.response.use(undefined, err => {
    const error = err.response;
    if (error.status === 401) {
        localStorage.clear()
        window.location = "/"
    }
});


instance.interceptors.request.use(config => {
    config.headers.token = localStorage.getItem('token');
    return config;
}, error => {
    return Promise.reject(error);
});




export { instance }